import { ROUTE_ACCOUNT_EDIT_MEMBERSHIP } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './edit-membership.page';

export const routeEditMembership: RouteObject = {
  path: ROUTE_ACCOUNT_EDIT_MEMBERSHIP,
  Component: Page,
  loader: setTitleFromLoader('Membership'),
};
